export default {
  LOGIN: "LOGIN",
  SUCCESS: "LOGIN_SUCCESS",
  FAIL: "LOGIN_FAIL",
  LOGOUT: "LOGOUT",
};
